import React from "react"

export const SectionHeader = ({ eyebrow, title }) => (
    <div className="lf-secHead">
        <div className="lf-eyebrow">{eyebrow}</div>
        <h2>{title}</h2>
    </div>
)
